import { connect } from 'react-redux';
import get from 'lodash/get';

import { setUserData } from 'dux/user/actions';
import { getUserAuthenticated } from 'dux/user/selectors';
import { getCurrentRoute } from 'dux/router/selectors';
import { initializeRouter } from 'dux/router/router';

const mapStateToProps = (state: any) => ( {
    isLoggedIn: getUserAuthenticated( state ),
    requiresAuth: get( getCurrentRoute( state ), 'requiresAuth', true ),
} );

const mapDispatchToProps = {
    setUserData,
    initializeRouter,
};

export default connect( mapStateToProps, mapDispatchToProps );
